﻿
class PtwAnalytics {
    constructor(props, context) {
    }
    process(analyticsData) {
        const data = analyticsData.data;
        let environmentSuffix = '';
        if (data && data.length > 0 && data[0] && data[0].length >=3 && data[0][0] == 'init') {
            environmentSuffix = "-" + data[0][2];
        }
        const argumentArray = data.map(d => Array.from(d));
        let postUrl = `https://analytics-fn${environmentSuffix}.pricetweakers.net/api/HttpFnSendToEventHub`;
        fetch(postUrl,
            {
                method: 'post',
                body: JSON.stringify(argumentArray),
                credentials: 'same-origin'
            }).then(response => {
                response.text().then(responseText => {
                    console.log(responseText);
                });
            });
    }
}   

PtwAnalytics.staticStuff = {

};

const analyticsObject = new PtwAnalytics();

try {
    analyticsObject.process(window.ptanalytics);
}
catch (err) {
    console.log(err);
}

export default PtwAnalytics;